import type { RewardTrigger } from './campaign-form';
import type { MgmRole } from './types';

/**
 * Frases do benefício, geradas das regras — o master nunca precisa reescrever
 * "quanto e quando" à mão, e a página, o convite e o admin dizem a mesma coisa.
 */

export type Perspective = 'admin' | 'referrer' | 'referred';

export function rewardSentence(
  role: MgmRole,
  amountText: string,
  trigger: RewardTrigger,
  perspective: Perspective,
): string {
  const whenReferred = trigger === 'first_purchase' ? 'na primeira compra' : 'ao se cadastrar';
  const whenFriend = trigger === 'first_purchase' ? 'fizer a primeira compra' : 'se cadastrar';

  if (perspective === 'admin') {
    return role === 'referrer'
      ? `Quem indica ganha ${amountText} quando o indicado ${whenFriend}.`
      : `Quem é indicado ganha ${amountText} ${whenReferred}.`;
  }
  if (perspective === 'referrer') {
    return role === 'referrer'
      ? `Você ganha ${amountText} quando seu amigo ${whenFriend}.`
      : `Seu amigo ganha ${amountText} ${whenReferred}.`;
  }
  // referred: quem abriu o convite
  return role === 'referred'
    ? trigger === 'first_purchase'
      ? `Cadastre-se e ganhe ${amountText} na sua primeira compra.`
      : `Cadastre-se e ganhe ${amountText}.`
    : '';
}

/** Substitui {amount}/{name} para a prévia da notificação. */
export function renderPush(template: string, vars: { amount: string; name: string }): string {
  return template.replace(/\{(amount|name)\}/g, (_, key: 'amount' | 'name') => vars[key]);
}
